import { jsonCopy } from '../../../utility/genericUtility';
import { datiTitolareEffettivoBenefVitaInizializzato } from '../componentiBase/sezioniAnagrafica';

export const datiTitolareBenefVitaEff = jsonCopy(datiTitolareEffettivoBenefVitaInizializzato);


